import { useTranslation } from "react-i18next"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Stack from "@mui/material/Stack"
import { DateTime } from "luxon"

import CustomLink from "widgets/common/CustomLink"

const Footer = () => {
  const { t } = useTranslation()

  return (
    <Box
      component={"footer"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      my={3}
    >
      <Stack
        flexDirection={"row"}
        flexWrap={"wrap"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <CustomLink href={"/terms-and-conditions/"} target="_blank" underlineHover>
          {t("generic.TERMS_AND_CONDITIONS")}
        </CustomLink>
        <Typography
          variant="body2"
          align="center"
          component="p"
          sx={{ color: (theme) => theme.palette.grey[400] }}
        >
          &nbsp;&nbsp;|&nbsp;&nbsp;
        </Typography>
        <CustomLink
          href={"https://www.sentrisense.com/privacy-policy/"}
          target="_blank"
          underlineHover
        >
          {t("generic.PRIVACY_POLICY")}
        </CustomLink>
      </Stack>
      <Typography
        variant="body2"
        align="center"
        component="p"
        mt={1}
        sx={{ color: (theme) => theme.palette.grey[400] }}
      >
        &copy; {DateTime.now().year} - Sentrisense, a Doble-Megger Company&reg;
      </Typography>
    </Box>
  )
}

export default Footer
